export const SafraSchema = '++id, idApi, value, display, tpepoca, updatedAt, isSynced';

export const safraMapper = {
  toEntity: (apiData) => {
    return apiData.map(safra => ({
      idApi: safra.ID,        // ID da API
      value: safra.VALUE,     // "2024/2025"
      display: safra.DISPLAY, // "2024/2025"
      tpepoca: safra.TPEPOCA, // "V"
      updatedAt: new Date().getTime(),
      isSynced: true
    }));
  }
};
